export const TEXT = {
  0: {
    titleKey: 'Decedent info',
    labelKey:
      'Please verify the information used to create your account. If anything displayed is incorrect, please correct it.',
  },
  1: {
    titleKey: 'Decedent’s residence',
    labelKey: 'Please enter decedent’s legal residence at time of death.',
  },
  2: {
    titleKey: 'Decedent’s marital status',
    labelKey: 'Please specify the decedent’s marital status',
  },
  3: {
    titleKey: 'Decedent’s dependants',
    labelKey: 'Please specify if the decedent had any dependants',
  },
  4: {
    titleKey: 'Documentation Submissions',
    labelKey:
      'Please specify death registration or applications submitted by a Funeral Home or other agent',
  },
};

export const STEPS = [
  'Main info',
  'Residence',
  'Marital status',
  'Dependants',
  'Documentation Submissions',
];

export const STEPS_FORM = [
  'basic_main',
  'basic_residence',
  'basic_marital',
  'basic_dependants',
  'basic_document_submission',
];
